import { Component, ViewEncapsulation } from "@angular/core";
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '../shared/footer/footer.component';
import { TenantPublicContentService } from '../tenant/tenant-public-content.service';

@Component({
  selector: 'app-refund-policy',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FooterComponent
  ],
  templateUrl: './refund-policy.component.html',
  styleUrls: ['./refund-policy.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class RefundPolicyComponent {
  content$ = this.tenantContent.content$;

  constructor(private tenantContent: TenantPublicContentService) {}
}

